import { maLookback } from '../../math/ma'
import { COLOR, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'STOCHRSI',
  version: 1,
  label: 'Stochastic RSI',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 240,
  inputs: [
    period('timeperiod', 14, 'RSI length'),
    period('fastk_period', 5, '%K length', 1),
    period('fastd_period', 3, '%D smoothing', 1),
    matype('fastd_matype', 0, '%D MA type'),
  ],
  outputs: [line('fastk', '%K', COLOR.blue), line('fastd', '%D', COLOR.orange)],
  levels: [{ value: 80 }, { value: 20 }],
  talib: {
    functions: ['STOCHRSI'],
    expr: 'STOCHRSI(close, timeperiod={timeperiod}, fastk_period={fastk_period}, fastd_period={fastd_period}, fastd_matype={fastd_matype})',
    outputs: { fastk: 'fastk', fastd: 'fastd' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, fastk_period, fastd_period, fastd_matype }) => timeperiod + fastk_period - 1 + maLookback(fastd_period, fastd_matype),
}
export default def
